export const MasterProductFormValidations = {
  id: [{ type: 'required', message: 'ID is required' }],

  category_code: [{ type: 'required', message: 'Category ID is required' }],
  name: [{ type: 'required', message: 'Product name is required' }],
  brand: [{ type: 'required', message: 'Brand is required' }],
  price: [
    { type: 'required', message: 'Price is required' },
    { type: 'pattern', value: /^[0-9]+(\.[0-9]{1,2})?$/, message: 'Price must be a valid number' },
  ],
  selling_price: [
    { type: 'required', message: 'Price is required' },
    { type: 'pattern', value: /^[0-9]+(\.[0-9]{1,2})?$/, message: 'Price must be a valid number' },
  ],
  code: [{ type: 'required', message: 'Product code is required' }],
  provider_code: [{ type: 'required', message: 'Provider code is required' }],
  provider_product: [{ type: 'required', message: 'Provider product is required' }],

  admin_fee: [
    { type: 'required', message: 'Admin fee is required' },
    { type: 'pattern', value: /^[0-9]+(\.[0-9]{1,2})?$/, message: 'Admin fee must be a valid number' },
  ],

  active: [{ type: 'required', message: 'Active status is required' }],
};
